<template>
    <v-card flat tile data-testid="top-header-menu">
        <v-toolbar
            flat
            short
            tile
            height="30px"
            class="pa-0"
        >
            <v-toolbar-title />
            <v-spacer />
            <menu-items />
        </v-toolbar>
    </v-card>
</template>

<script>
import menuItems from './MenuItems';

export default {
    name: 'top-header-menu',
    components: {
        menuItems,
    },
};
</script>
<style scoped lang="scss">

.v-toolbar::v-deep .v-toolbar__content {
    max-width: 1510px;
    margin: auto;
    @media only screen and (max-width: 1264px) {
        width: 100%;
    }
}
</style>
